const HighlightMatch = ({ text, query }: { text: string; query: string }) => {
  if (!query) return null;

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const matchIndex = lowerText.indexOf(lowerQuery);

  if (matchIndex === -1) return null;

  const before = text.slice(0, matchIndex);
  const match = text.slice(matchIndex, matchIndex + query.length);
  const after = text.slice(matchIndex + query.length);

  return (
    <>
      <span>{before}</span>
      <strong>{match}</strong>
      <span>{after}</span>
    </>
  );
};

export default HighlightMatch;
